export enum OperatorType {
  EQUAL = 0,
  NOT_EQUAL = 1,
  GREATER_THAN = 2,
  LESSER_THAN = 3,
  REGEX = 4
}
